const assign = (data, allFiles) => {
    if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const each = Object.assign({
                id: data[i].id,
                url: data[i].url,
            });
            allFiles.push(each);
        }
    }
}

export default assign;